import { createContext, useContext } from 'react'

// True inside the page body when the account is read-only (PHX-2785); shared
// controls read it so they also disable when rendered in a portal
const ReadOnlyContext = createContext(false)

export const useIsReadOnly = () => useContext(ReadOnlyContext)

export default ReadOnlyContext
